'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable no-console */
function storageAvailable(type) {
    try {
        var storage = window[type];
        var key = '__storage_test__';
        storage.setItem(key, key);
        storage.removeItem(key);
        return true;
    } catch (err) {
        return false;
    }
}

function setJson(key, json) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'sessionStorage';

    if (storageAvailable(type)) {
        var storage = window[type];
        storage.setItem(key, JSON.stringify(json));
        return true;
    }
    return false;
}

function getJson(key) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'sessionStorage';

    var resp = null;
    if (storageAvailable(type)) {
        var storage = window[type];
        var value = storage.getItem(key);
        try {
            resp = JSON.parse(value);
        } catch (err) {
            console.log('Error parsing JSON: ', err);
        }
    }
    return resp;
}

exports.setJson = setJson;
exports.getJson = getJson;


//////////////////
// WEBPACK FOOTER
// ./node_modules/watch-authenticators/build/WebStorage.js
// module id = 667
// module chunks = 1